module.exports = __webpack_public_path__ + "img/tav-guvenlik-mobile.564252b7.jpg";